import {
  head,
  isEmpty,
  keys,
  values as objectValues,
  omit,
  omitBy,
} from 'lodash'

export const CommercialCombinedGuidConverter = (guidData: any) => {
  let formDataObj: any = {}
  guidData?.forEach((item: any, idx: number) => {
    // STEP 1
    if (idx === 0 && !isEmpty(item)) {
      item = { activity: `${item.activity}` }
    }

    // STEP 2
    if (idx === 1 && !isEmpty(item)) {
      item = {
        insuranceCover: item?.selectedCoverType,
        selectedCoverName: item?.selectedCoverName,
      }
    }

    if (idx === 2) {
      item = {
        ...item,
        currentInsurerId: item?.currentInsurerId || '',
      }

      if (item?.currentInsurerId !== '78') {
        item = omit(item, ['currentInsurerOther'])
      }
    }

    // STEP 4
    if (idx === 3 && !isEmpty(item)) {
      item = {
        publicLiabilityIndemnityLevel: item?.plIndemnityLevel,
        employersLiabilityCoverAmountLevel: item?.elIndemnityLevel,
      }
    }

    // STEP 5
    if (idx === 4 && !isEmpty(item)) {
      item = {
        locations: item?.locations?.map((location: any) => {
          return {
            postcode: location?.postcode,
            town: location?.town || '',
            city: location?.city,
            county: location?.county,
            houseNo: location?.address1,
            street: location?.address2,
          }
        }),
        operatesAnotherLocation: item?.operatesAnotherLocation,
      }
    }

    // STEP 6

    if (idx === 5 && !isEmpty(item)) {
      const newDetailItems = item?.coverDetailsItems
        ?.slice(0, 10)
        ?.map((detailItem: any) => {
          return {
            ...detailItem,
            values: detailItem?.values?.map((value: any) => head(value)),
          }
        })

      // VehicleItems
      const vehicles =
        item.coverDetailsItems[item?.coverDetailsItems.length - 1]

      const newVehicles = {
        added: vehicles.added,
        values: vehicles?.values?.map((value: any) => {
          return {
            vehiclesInBuilding: value[0],
            vehiclesInCompound: value[1],
            vehiclesInTheOpen: value[2],
            maxValue: value[3],
            hasExpensiveVehicles: !!value[3],
          }
        }),
      }

      item = {
        coverDetailsItems: newDetailItems,
        vehicleAtPremises: newVehicles,
      }
    }

    // STEP 7
    if (idx === 6 && !isEmpty(item)) {
      const goodInTransit = item
      item = {
        contactAddress: item?.contactAddress,
        tradingAs: item?.tradingAs,
        policyHolderFirstName: item?.policyHolderFirstName,
        policyHolderSurname: item?.policyHolderSurname,
        businessTypeId: `${item?.businessTypeId}`,
        policyHolderTitleId: `${item?.policyHolderTitleId}`,

        additional: {
          specifiedAllRisksCoverAdded: item?.specifiedAllRisksCoverAdded,
          specifiedAllRisksTypes: item?.specifiedAllRisksTypes?.map(
            (risk: any) => {
              return {
                ...risk,
                id: 0,
                text: risk?.text || '',
              }
            }
          ),
          specifiedAllRisksMaxValueSingle:
            item?.specifiedAllRisksMaxValueSingle,
          personalAccidentCoverAdded: item?.personalAccidentCoverAdded,
          personalAccidentAnyInsuredApplicationDeclinedOrImposed:
            item?.personalAccidentAnyInsuredApplicationDeclinedOrImposed,
          personalAccidentAnyInsuredApplicationDeclinedOrImposedDetails:
            item?.personalAccidentAnyInsuredApplicationDeclinedOrImposedDetails,
          personalAccidentAnyInsuredOver70:
            item?.personalAccidentAnyInsuredOver70,

          personalAccidentUnitsRequired: item?.personalAccidentUnitsRequired
            ? Number(item?.personalAccidentUnitsRequired)
            : 0,

          lossOfLicenceCoverAdded: item?.lossOfLicenceCoverAdded,
          lossOfLicencePreviousPendingConvictions:
            item?.lossOfLicencePreviousPendingConvictions,
          lossOfLicencePreviousPendingConvictionsDetails:
            item?.lossOfLicencePreviousPendingConvictionsDetails,

          lossOfLicencePreviousWarningsOrNotices:
            item?.lossOfLicencePreviousWarningsOrNotices,
          lossOfLicencePreviousWarningsOrNoticesDetails:
            item?.lossOfLicencePreviousWarningsOrNoticesDetails,
          lossOfLicenceIssuingAuthority: item?.lossOfLicenceIssuingAuthority,
          lossOfLicenceDateOfIssue: item?.lossOfLicenceDateOfIssue,
          lossOfLicenceSumInsured: item?.lossOfLicenceSumInsured,
          lossOfLicenceType: item?.lossOfLicenceType,

          goodsInTransitCoverAdded: item?.goodsInTransitCoverAdded,
          goodsInTransitMaxValueSingleTransit:
            item?.goodsInTransitMaxValueSingleTransit,
          goodsInTransitAnnualValue: item?.goodsInTransitAnnualValue,
          moneyCoverAdded: item?.moneyCoverAdded,
          premisesInNonBusinessHoursSafe: `${item?.premisesInNonBusinessHoursSafe}`,
          premisesInNonBusinessHoursNonSafe: `${item?.premisesInNonBusinessHoursNonSafe}`,
          premisesInBusinessHours: `${item?.premisesInBusinessHours}`,
          inTransitFromBank: `${item?.inTransitFromBank}`,
          estimatedAnnualCarrying: `${item?.estimatedAnnualCarrying}`,
          businessInterruptionCoverAdded: item?.businessInterruptionCoverAdded,
          businessInterruptionBasisIfCoverId: `${item?.businessInterruptionBasisIfCoverId}`,
          businessInterruptionIndemnityPeriodId: `${item?.businessInterruptionIndemnityPeriodId}`,
          businessInterruptionSum: item?.businessInterruptionSum,
          personalAccidentAnyInsuredPreExistingConditions:
            item?.personalAccidentAnyInsuredPreExistingConditions,
          deteriorationOfStockCoverAdded: item?.detoriationOfStockCoverAdded,
          deteriorationOfStockSum: item?.detoriationOfStockSum,
        },
      }

      if (
        goodInTransit?.goodsInTransitTypes?.find(
          (type: any) => type?.selected === true
        )
      ) {
        const goodInTransitArr = ['portable', 'diagnostic', 'stock', 'vehicles']
        goodInTransit?.goodsInTransitTypes?.forEach(
          (type: any, idx: number) => {
            if (type.selected) {
              item.additional[`${goodInTransitArr[idx]}`] = true
              item.additional[`${goodInTransitArr[idx]}_details`] =
                type.sumInsured
            }
          }
        )
      }
    }

    // STEP 8
    if (idx === 7 && !isEmpty(item)) {
      item = {
        ...item,
        tradeTypeId: `${item?.insuredTradeTypeId}`,
        activities: item?.activities?.map((activity: any) => {
          return {
            title: activity?.name,
            occupationId: `${activity?.id}`,
            percentage: activity?.value,
          }
        }),
      }
    }

    // STEP 9
    if (idx === 8 && !isEmpty(item)) {
      item = {
        numberOfManualEmployees: item?.numberOfManualEmployees,
        numberOfClericalEmployees: item?.numberOfClericalEmployees,
        operatePAYE: item?.paye,
        ern: item?.payeERN || '',
        ernExempt: item?.payeERNExempt,
      }
    }

    // STEP 10
    if (idx === 9 && !isEmpty(item)) {
      item = {
        employBonaFideSubcontract: item.employBonaFide,
        employBonaFideSubcontractPercentage: `${item?.bonaFideAnnualPct}`,
      }
    }

    // STEP 11
    if (idx === 10 && !isEmpty(item)) {
      item.exportGoodsOutsideUK = item?.outsideUK
      if (item?.europe) item.exportGoodsToEuropePercentage = `${item?.europe}`
      if (item?.usaCanada)
        item.exportGoodsToUsaCanadaPercentage = `${item?.usaCanada}`
      if (item?.restOfTheWorld)
        item.exportGoodsToOtherPercentage = `${item?.restOfTheWorld}`
    }

    // STEP 12
    if (idx === 11) {
      let step12: any = {}
      objectValues(item).forEach((point: any, idx: number) => {
        if (point === true) {
          step12[`${keys(item)[idx]}`] = point
          step12[`${keys(item)[idx]}Details`] = keys(item)[idx + 1]
        } else {
          return
        }
      })
      item = step12
    }

    // STEP 13
    if (idx === 12 && !isEmpty(item)) {
      item = {
        undertakeWorkAwayFromPremisesHeatWork: item?.undertakenWork,
        undertakeWorkAwayFromPremisesHeatWorkPercentage: `${item?.undertakenWorkPercentage}`,
      }
    }

    // STEP 14
    if (idx === 13) {
      let step14: any = {}
      objectValues(item).forEach((point: any, idx: number) => {
        if (point === true) {
          step14[`${keys(item)[idx]}`] = point
          step14[`${keys(item)[idx]}Details`] = keys(item)[idx + 1]
        } else {
          return
        }
      })
      item = step14
    }

    // STEP 15
    if (idx === 14 && !isEmpty(item)) {
      if (item?.madeClaim && item?.claims) {
        item = {
          claim: true,
          claims: item?.claims.map((claim: any) => {
            return {
              claim_future: claim?.futureReoccurrence,
              description: claim?.claimDetails,
              value: `${claim?.claimValue}`,
              claim_type: `${claim?.claimCategory}`,
              made_claim: claim?.incidentDate,

              ...(claim?.claimCategory === 1 && {
                propertyOptions: `${claim?.claimType}`,
              }),
              ...(claim?.claimCategory === 2 && {
                liabilityOptions: `${claim?.claimType}`,
              }),
            }
          }),
        }
      } else {
        item = {
          claim: false,
        }
      }
    }

    // STEP 16
    if (idx === 15 && !isEmpty(item)) {
      item = {
        retainRightsOfRecovery: item?.materialsAndServices,
        importProductsOrMaterialsOutsideUK: item?.importProductOutside,
        retainRightsOfRecoveryDetails: item?.materialsAndServicesDetails,
        importProductsOrMaterialsOutsideUKDetails:
          item?.importProductOutsideDetails,
      }
    }

    // STEP 17
    if (idx === 16 && !isEmpty(item)) {
      item = {
        goodsSuppliedRecordsKept: item?.identifyTheCustomer,
        goodsSuppliedRecordsKeptDetails: item?.reasonWhy,
      }
    }

    // STEP 18
    if (idx === 17 && !isEmpty(item)) {
      item = {
        carryOutPractices: item?.followingPractices,
        carryOutPracticesDetails: item?.followingPracticesDetails,
      }
    }

    // STEP 19
    if (idx === 18 && !isEmpty(item)) {
      item = {
        locations: item?.locations.map((location: any) => {
          return omitBy(
            {
              entirelySelfContained: location?.selfContained,
              entirelySelfContainedDetails: location?.selfContainedDetails,
              gradeOrCategory: location?.categoryListed,
              gradeOrCategoryId: location?.premisesCategoryId,
              inGoodStateAndMaintained: location?.maintained,
              inGoodStateAndMaintainedDetails: location?.maintainedDetails,
              heatedSolelyByElectricityOrGas: location?.heatedSolelyBy,
              heatedSolelyByElectricityOrGasDetails:
                location?.heatedSolelyByDetails,
              flatRoof: location?.flatRoof,
              flatRoofPercentage: Number(location?.flatRoofPercentage),
              hasBuildOfBrickStoneOrConcrete: location?.buildingMaterial,
              hasBuildOfBrickStoneOrConcreteDetails:
                location?.buildingMaterialDetails,
            },
            (value) => value === null
          )
        }),
      }
    }

    // STEP 20
    if (idx === 19 && !isEmpty(item)) {
      item = {
        locations: item?.locations.map((location: any) => {
          return omitBy(
            {
              hasFrostStateActivatedOrPipesLagged: location?.heatingFrostFree,
              portableHeaters: location?.portableHeaters,
              portableHeatersDetails: location?.portableHeatersDetails,
            },
            (value) => value === null
          )
        }),
      }
    }

    // STEP 21
    if (idx === 20 && !isEmpty(item)) {
      item = {
        locations: item?.locations.map((location: any) => {
          return omitBy(
            {
              ageOfOldestPart: location?.buildingOldestPart,
              detachedFromNeighbouringProperties: location?.detached,
              adjoiningOccupantsBusinessActivitiesDetails:
                location?.detachedDetails,
            },
            (value) => value === null
          )
        }),
      }
    }

    // STEP 22
    if (idx === 21 && !isEmpty(item)) {
      item = {
        locations: item?.locations.map((location: any) => {
          return {
            hasWholeElectricalSystemInspected:
              location?.hasWholeElectricalSystemInspected,
            electricalConditionReport: location?.electricalConditionReport,
            hasPortableApplianceTesting: location?.portableApplianceTesting,
          }
        }),
      }
    }

    // STEP 23
    if (idx === 22 && !isEmpty(item)) {
      item = {
        locations: item?.locations.map((location: any) => {
          return {
            isLetAsResidentalAccommodation: location?.isLetAsResidential,
            gasCertifcateIssuedByGasSafeRegisteredEngineer:
              location?.isLetAsResidentialGasSafety,
            hasValidGasAnnualSafety: location?.ensureGasCertificate,
          }
        }),
      }
    }

    // STEP 25
    if (idx === 24 && !isEmpty(item)) {
      item = {
        locations: item?.locations.map((location: any) => {
          return omitBy(
            {
              ...location,
              subsidenceGroundHeaveLandslipDetails:
                location?.SubsidenceGroundHeaveLandslipCoverAddedRestrictionsApplyDetails,
            },
            (value) => value === null
          )
        }),
      }
    }

    // STEP 26
    if (idx === 25 && !isEmpty(item)) {
      item = {
        doorsAndWindowsSecured: item?.windowsGrilledFittedWithLocks,
        doorsAndWindowsSecuredDetails:
          item?.windowsGrilledFittedWithLocksDetails,
        intruderAlarm: item?.hasIntruderAlarm,
        intruderAlarmTypeId: item?.haveIntruderAlarmTypeId,
        intruderAlarmAnnualMaintenance:
          item?.haveAlarmMaintenanceContractWithCompanyAccreditedSSAIBorNSI,
        safeOrVaultInstalled: item?.haveSafeVaultInstalled,
        safeOrVaultMake: item?.safeVaultMake,
        safeOrVaultModel: item?.safeVaultModel,
      }
    }

    formDataObj[`step${idx + 1}`] = item
  })

  return {
    ...formDataObj,
  }
}
